import { captureMessage } from '@sentry/nextjs'

import fetchRequest from '@/app/_utils/fetch-request'

import { ThirdPartyScriptData, ThirdPartyScriptDataSchema } from './response-data-validator'

export const fetchThirdPartyScriptsConfig = async (isServerSideRequest: boolean): Promise<ThirdPartyScriptData> => {
    const response = await fetchRequest({
        method: 'GET',
        serviceName: 'cml',
        endpoint: '/cases/third-party-scripts',
        isServerSideRequest,
        onError: (error) =>
            captureMessage('third-party-scripts: fetch failed!', {
                tags: {
                    feature: 'third-party-scripts',
                    reason: 'schema_validation_failed',
                    sampleRate: '1.0',
                },
                extra: {
                    error,
                },
            }),
    })

    const result = ThirdPartyScriptDataSchema.safeParse(response)

    if (!result.success) {
        captureMessage('third-party-scripts: response is not valid!', {
            tags: {
                feature: 'third-party-scripts',
                reason: 'schema_validation_failed',
                sampleRate: '1.0',
            },
            extra: {
                zodErrors: result.error.flatten(),
                response,
            },
        })

        throw new Error('Invalid third party scripts config')
    }

    return result.data
}
